import HeaderToolbar from 'src/shared/components/navigations/headerToolbar';

import PageContainer from 'src/shared/components/organisms/pageContainer';
import ToastConfigure from 'src/shared/components/organisms/toastConfigure';

import { CssBaseline, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import SideMenuUser from 'src/shared/components/navigations/side-menu/sideMenuUser';
import { SignalRProvider } from 'src/shared/contexts/signalRProvider';
import { SignalRMessageHandler } from './signalRMessageHandler';

export const UserLayout = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <HeaderToolbar />
      <SideMenuUser />
      <PageContainer>
        <SignalRProvider>
          <SignalRMessageHandler />
          <Outlet />
        </SignalRProvider>
      </PageContainer>
      <ToastConfigure />
    </Box>
  );
};
